import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const canva = defineConnector({
  identifier: "canva",
  name: "Canva",
  tagLine: "Online design platform",
  logo,
  protocol: "http",
  tags: ["productivity", "documents"],
  defaultUrlPattern: () => "https://api\\.canva\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Canva integration",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Canva developer integrations](https://www.canva.com/developers/integrations/connect-api) and click **Create an integration**. Give it a name.",
        },
      ],
    },
    {
      title: "Enter your OAuth credentials",
      items: [
        {
          kind: "markdown",
          content:
            "From the **Configuration** page, copy the **Client ID**, then click **Generate secret** and copy it.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Define scopes for this connection",
      items: [
        {
          kind: "markdown",
          content:
            "In the **Scopes** section, enable the scopes your integration needs. Enter the same scopes below, using the format `scope:read` or `scope:write` (e.g. `design:meta:read`).",
        },
        {
          kind: "input",
          label: "Scopes",
          required: true,
          defaultValue: "design:meta:read",
          helperText:
            "Space separated. Combine the scope name and column: design:meta + Read = design:meta:read.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content:
            "In the **Authentication** section, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/canva/callback",
        },
      ],
    },
    {
      title: "Authorize your Canva account",
      items: [
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
            { kind: "oauthConnection", field: "scopes" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://www.canva.com/api/oauth/authorize",
    tokenEndpoint: () => "https://api.canva.com/rest/v1/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
    pkce: () => true,
  },
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.canva.com/rest/v1/users/me",
      expectedStatus: [200, 403],
    }),
  },
});
